// extracted by css-extract-rspack-plugin
export default {"disabledItem":"VbKZr","infoIconContainer":"yE3dF","infoIcon":"jsEi6"};